const parseValue = (value: number | string) => {
  if (typeof value === "number") {
    return { unit: "px", value };
  }

  if (value.endsWith("%")) {
    return { unit: "%", value: parseFloat(value) };
  }

  return { unit: "px", value: parseFloat(value) };
};

export default parseValue;
